import {BaseEntity} from "./BaseEntity";

export class LocationHistory implements BaseEntity {
    constructor(
        public id?:number,
        public locationName?:string,
        public assetName?:string,
        public timeSeen?: string,
        public timeLeft?: string,
        public assetID?:string){
    }
    parseJson(json: any): void {
        this.id = json.id;
        this.locationName = json.locationName;
        this.assetName = json.assetName;
        this.timeSeen = json.timeSeen;
        this.timeLeft = json.timeLeft;
        this.assetID = json.assetID;
    }
}
